// src/components/common/icons/CheckCircleIcon.js
import React from 'react';

export const CheckCircleIcon = ({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 text-blue-500 mr-2 flex-shrink-0 ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);
